import type { OrgSummary } from '@aiai/shared';

/** An item tagged with the workspace it belongs to (every /me item is). */
export interface WorkspaceTagged {
  workspace: OrgSummary;
}

export interface WorkspaceGroup<T> {
  workspace: OrgSummary;
  items: T[];
}

/**
 * Group workspace-tagged items by their workspace, preserving each item's
 * incoming order within a group. Groups are ordered by workspace name so the
 * cross-workspace lists read stably regardless of fan-out timing.
 */
export function groupByWorkspace<T extends WorkspaceTagged>(
  items: T[],
): WorkspaceGroup<T>[] {
  const groups = new Map<string, WorkspaceGroup<T>>();
  for (const item of items) {
    let group = groups.get(item.workspace.id);
    if (!group) {
      group = { workspace: item.workspace, items: [] };
      groups.set(item.workspace.id, group);
    }
    group.items.push(item);
  }
  return [...groups.values()].sort((a, b) =>
    a.workspace.name.localeCompare(b.workspace.name),
  );
}
